import { NavLink } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Icon } from '@etnas/design-system';
import { inboxApi, tasksApi } from '@/api';
import { useAuth } from '../auth';
import { workspaceRail } from '../workspaces';

/** Rail (zone 1) with real navigation. Same markup/classes as the DS Rail; badges count only critical work. */
export function AppRail() {
  const { me } = useAuth();
  const role = me?.context.role.key;
  const items = me && role ? workspaceRail(role, me.context.roleId, me.permissions) : [];
  const wantsInbox = items.some((i) => i.badge === 'inbox-critical');
  const wantsTasks = items.some((i) => i.badge === 'tasks-critical');
  const counts = useQuery({ queryKey: ['inbox', 'counts'], queryFn: inboxApi.counts, enabled: wantsInbox, refetchInterval: 60_000 });
  const tasks = useQuery({ queryKey: ['tasks', 'list', { owner: 'me' }], queryFn: () => tasksApi.list({ owner: 'me' }), enabled: wantsTasks, refetchInterval: 60_000 });
  const badge = (b?: string) =>
    b === 'inbox-critical' ? counts.data?.critical ?? 0 : b === 'tasks-critical' ? tasks.data?.items.filter((t) => t.priority === 'critical' && t.status !== 'completed').length ?? 0 : 0;
  return (
    <nav className="ex-rail" aria-label="Workspaces">
      <div className="ex-rail-mark" aria-hidden="true">E</div>
      {items.map((it) => {
        const n = badge(it.badge);
        return (
          <NavLink key={it.id} to={it.to} end={it.to === '/admin' || it.to === '/revenue'} className={({ isActive }) => 'ex-rail-item' + (isActive ? ' is-active' : '')}>
            <span className="ex-rail-icon">
              <Icon name={it.icon} size={20} />
              {n ? (
                <span className="ex-rail-badge ex-tone-critical" aria-hidden="true">
                  {n}
                </span>
              ) : null}
            </span>
            <span className="ex-rail-label">{it.label}</span>
            {n ? <span className="ex-visually-hidden">, {n} critical</span> : null}
          </NavLink>
        );
      })}
      <span className="ex-rail-spacer" />
    </nav>
  );
}
